export const embeddableWebsites = [
  { name: 'WordPress', logo: require('./wp-logo.png') },
  { name: 'SquareSpace', logo: require('./squarespace-logo.png') },
  { name: 'Weebly', logo: require('./weebly-logo.png') },
  { name: 'Wix', logo: require('./wix-logo.png') },
  { name: 'Shopify', logo: require('./shopify-logo.png') },
  { name: 'Other Sites', logo: require('./othersites-logo.png') },
] as const
